var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tree"},[_c('TreeOrg',{ref:"treeOrg",attrs:{"data":_vm.data,"horizonta":_vm.horizonta,"render":_vm.renderContent,"label-style":_vm.style}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }